var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.91675V4.66675C17.5 6.31666 17.5 7.14162 18.0125 7.65418C18.5251 8.16675 19.3501 8.16675 21 8.16675H22.75",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 18.6666V9.33325C4.66669 6.03342 4.66669 4.38351 5.69181 3.35838C6.71694 2.33325 8.36685 2.33325 11.6667 2.33325H16.5336C17.0104 2.33325 17.2488 2.33325 17.4633 2.42206C17.6776 2.51087 17.8463 2.67947 18.1835 3.01667L22.6499 7.48316C22.9871 7.82036 23.1558 7.98897 23.2446 8.20337C23.3334 8.41777 23.3334 8.65621 23.3334 9.13309V18.6666C23.3334 21.9664 23.3334 23.6163 22.3082 24.6414C21.2831 25.6666 19.6332 25.6666 16.3334 25.6666H11.6667C8.36685 25.6666 6.71694 25.6666 5.69181 24.6414C4.66669 23.6163 4.66669 21.9664 4.66669 18.6666Z",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 12.8333H18.6666M9.33331 16.3333H18.6666M9.33331 19.8333H14.1992",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteRequests);
export default __webpack_public_path__ + "static/media/Quote-Requests.c78174aebbfc64bb064d5b1a30b37407.svg";
export { ForwardRef as ReactComponent };